import {
  CHEMICAL_RETARDANT_TREATMENT,
  GRAZING_TREATMENT,
  MINERAL_EARTH_TREATMENT,
  PRESCRIBED_BURN_TREATMENT,
  PRUNING_TREATMENT,
  REVEGETATION_TREATMENT,
  SILVICULTURE_TREATMENT,
  UNDERSTORY_THINNING_TREATMENT,
} from "../constants/treatmentTypes";

/** Material icon name for a treatment type, so the type reads from an icon
 *  (list rows, map labels) and colour stays free for the burn year. */
export const treatmentTypeIcon = (type: string | undefined | null): string => {
  switch (type) {
    case PRESCRIBED_BURN_TREATMENT:
      return "local_fire_department";
    case REVEGETATION_TREATMENT:
      return "park";
    case GRAZING_TREATMENT:
      return "grass";
    case PRUNING_TREATMENT:
      return "content_cut";
    case UNDERSTORY_THINNING_TREATMENT:
      return "forest";
    case MINERAL_EARTH_TREATMENT:
      return "agriculture";
    case SILVICULTURE_TREATMENT:
      return "nature";
    case CHEMICAL_RETARDANT_TREATMENT:
      return "water_drop";
    default:
      return "category";
  }
};

/** Map fill colour for a treatment, keyed to the year of the date it takes
 *  effect. Shared by the Treatments map layer and the scenario bar rows so
 *  a row's swatch matches its polygon. */
export const treatmentYearColor = (dateStr?: string | null): string => {
  if (!dateStr) return "hsl(0,0%,60%)";
  const year = new Date(dateStr).getFullYear();
  if (Number.isNaN(year)) return "hsl(0,0%,60%)";
  const startYear = 1910;
  const hue = (year - startYear) * 137.508; // golden angle for distinct colours
  return `hsl(${hue % 360}, 70%, 50%)`;
};

/** The date the map layer colours a treatment by (its EndDate). */
export const treatmentEffectDate = (
  properties: Record<string, unknown> | undefined | null
): string | undefined => {
  const date = properties?.EndDate;
  return typeof date === "string" && date ? date : undefined;
};

export const treatmentYear = (
  properties: Record<string, unknown> | undefined | null
): number | null => {
  const date = treatmentEffectDate(properties);
  if (!date) return null;
  const year = new Date(date).getFullYear();
  return Number.isNaN(year) ? null : year;
};
